import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './@core/guards/auth-guard.service';

export const routes: Routes = [
  {
    path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: () => import('@app/pages/pages.module')
      .then(m => m.PagesModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('@app/authentication/auth.module')
      .then(m => m.NgxAuthModule),
  },
  {
    path: 'error',
    loadChildren: () => import('@app/error/error.module')
      .then(m => m.ErrorModule),
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

export const config: ExtraOptions = {
    useHash: false
};

// @NgModule({
//   imports: [RouterModule.forRoot(routes, config)],
//   exports: [RouterModule],
// })
// export class AppRoutingModule {
// }
